import React, { useState, useContext } from 'react';
import ArrowButton from '../../components/arrowButton';
import useFaqListStyles from './styles';
import PageContext from '../../contexts/pageContext';

const FAQListing = ({ sectionData }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const {
    layout: { containerWidth },
    isMobile
  } = useContext(PageContext);
  const classes = useFaqListStyles({ selectedIndex, containerWidth, isMobile });
  const [nodeData] = sectionData.components;
  return (
    <section className={classes.section}>
      <div className={classes.sectionContainer}>
        <div className={classes.sectionSubheading}>
          <span
            ref={nodeData?.subheading?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.subheading.metadata.value
            }}
          />
        </div>
        <h2 className={classes.sectionHeading}>
          <span
            ref={nodeData?.title?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.title.metadata.value
            }}
          />
        </h2>

        <div className={classes.container}>
          {nodeData.faqQuestions.components.map((item, index) => (
            <Accordion
              key={index}
              item={item}
              onClick={() => {
                setSelectedIndex(index);
              }}
              isSelected={selectedIndex === index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const Accordion = ({ item, isSelected, onClick }) => {
  const classes = useFaqListStyles({ isSelected });

  return (
    <div className={classes.basicCardContainer}>
      <div onClick={onClick} className={classes.innerContainer}>
        <div className={classes.header}>
          <h3
            ref={item?.question?.refSetter}
            className={classes.title}
            dangerouslySetInnerHTML={{
              __html: item.question.metadata.value
            }}
          />
          <div className={classes.arrowButton}>
            <ArrowButton down={!isSelected} up={isSelected} size="small" />
          </div>
        </div>
        <div
          ref={item?.answer?.refSetter}
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: item.answer.metadata.value
          }}
        />
      </div>
    </div>
  );
};

export default FAQListing;
